import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlignCenterLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.5 16.198C2.5 14.5698 3.81979 13.25 5.448 13.25H19.052C20.6802 13.25 22 14.5698 22 16.198V18.802C22 20.4302 20.6802 21.75 19.052 21.75H5.448C3.81979 21.75 2.5 20.4302 2.5 18.802V16.198ZM5.448 14.75C4.64821 14.75 4 15.3982 4 16.198V18.802C4 19.6018 4.64821 20.25 5.448 20.25H19.052C19.8518 20.25 20.5 19.6018 20.5 18.802V16.198C20.5 15.3982 19.8518 14.75 19.052 14.75H5.448Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6 5.198C6 3.56979 7.31979 2.25 8.948 2.25H15.552C17.1802 2.25 18.5 3.56979 18.5 5.198V7.802C18.5 9.43021 17.1802 10.75 15.552 10.75H8.948C7.31979 10.75 6 9.43021 6 7.802V5.198ZM8.948 3.75C8.14821 3.75 7.5 4.39821 7.5 5.198V7.802C7.5 8.60179 8.14821 9.25 8.948 9.25H15.552C16.3518 9.25 17 8.60179 17 7.802V5.198C17 4.39821 16.3518 3.75 15.552 3.75H8.948Z",
		fill: "currentColor"
	})]
});
export default SvgAlignCenterLine;
